'use client';

import { useEffect } from 'react';
import { useParams } from 'next/navigation';
import { OutletHeader } from '@/src/shared/components/detail-outlet/OutletHeader';
import { OutletTabs } from '@/src/shared/components/detail-outlet/OutletTabs';
import { useOutletStore } from '@/src/stores/OutletStore';

export default function OutletDetailPage() {
  const { outletId } = useParams<{ outletId: string }>();
  const outletStore = useOutletStore();

  useEffect(() => {
    outletStore.getOutlet(outletId);
  }, [outletId]);

  return (
    <>
      <OutletHeader />
      <OutletTabs />
    </>
  );
}
